if (!customElements.get("custom-product-asset-slider")) {
  customElements.define(
    "custom-product-asset-slider",
    class CustomProductAssetSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!window.FoxTheme?.utils?.debounce) return;

        this.selectors = {
          sliderWrapper: ".featured-collection__items",
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        };
        this.classes = {
          grid: "f-grid",
          swiper: "swiper",
          swiperWrapper: "swiper-wrapper",
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === "true";
        this.variableSlideWidth = this.dataset.variableSlideWidth === "true";
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;
        this.handleResize = FoxTheme.utils.debounce(() => {
          this.calcNavButtonsPosition();
          this.calcHeadingColumnHeight();
          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.update();
          }
        }, 100);

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("load", this.handleResize, { once: true });

        if (!this.enableSlider) return;

        this.handleMediaChange = this.init.bind(this);
        this.mobileMediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mobileMediaQuery.onchange = this.handleMediaChange;

        if (this.variableSlideWidth) {
          this.blockMobileMediaQuery = window.matchMedia("(max-width: 1023.98px)");
          this.blockMobileMediaQuery.onchange = this.handleMediaChange;
        }

        this.init();
      }

      init() {
        if (this.isMobileLayout()) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      isMobileLayout() {
        return (
          FoxTheme.config.mqlMobile ||
          (this.variableSlideWidth && this.blockMobileMediaQuery && this.blockMobileMediaQuery.matches)
        );
      }

      initSlider() {
        if (typeof this.sliderInstance === "object") return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

        this.sliderOptions = {
          slidesPerView: this.variableSlideWidth ? "auto" : this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
          spaceBetween: columnGap.tablet,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            1024: {
              slidesPerView: this.variableSlideWidth ? "auto" : this.items > 4 ? 4 : parseInt(this.items),
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              slidesPerView: this.variableSlideWidth ? "auto" : parseInt(this.items),
              spaceBetween: columnGap.desktop,
            },
          },
          loop: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();

        this.handleResize();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== "object") return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== "true") return;

        const firstMedia = this.querySelector(
          ".product-card__image-wrapper, .featured-collection__media, .featured-collection__text-card",
        );
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            "--swiper-navigation-top-offset",
            parseInt(firstMedia.clientHeight) / 2 + "px",
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== "true") return;

        const firstMedia = this.querySelector(
          ".product-card__image-wrapper, .featured-collection__media, .featured-collection__text-card",
        );
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty("--heading-column-height", firstMedia.clientHeight + "px");
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll("quick-view-modal")).forEach((modal) => {
          const modalID = modal.getAttribute("id");
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("load", this.handleResize);
        if (this.mobileMediaQuery) {
          this.mobileMediaQuery.onchange = null;
        }
        if (this.blockMobileMediaQuery) {
          this.blockMobileMediaQuery.onchange = null;
        }
      }
    },
  );
}
